var map = {
	"./Communication.svg": "9caa",
	"./Fullscreen.svg": "7714",
	"./Lupe.png": "9941",
	"./Map.svg": "18d5",
	"./Sprungpunkt.png": "d4f1",
	"./Tutorial.svg": "9a80",
	"./black_background_for_publisher.png": "a729",
	"./bugreport icon.png": "b2c8",
	"./disclaimer.png": "958b",
	"./flux360-360-viewer-Button.svg": "2209",
	"./flux360-Tutorial_scroll.svg": "3d36",
	"./flux360-information-Button.svg": "2fb9",
	"./gyrosicon.png": "16ef",
	"./highlight.png": "83a1",
	"./ic_hang_up.png": "b03d",
	"./ic_join.png": "0163",
	"./ic_mediaControl.svg": "1d6d",
	"./icons8-adjust-50.png": "8b5e",
	"./no-thumb.png": "5288",
	"./panoramaThumbnail.jpg": "02cd",
	"./pause-button.png": "642d",
	"./pause.svg": "ec7e",
	"./play-button.png": "4867",
	"./play.png": "df84",
	"./play.svg": "5830",
	"./sounds/newMessage.mp3": "d198",
	"./sounds/ripple.mp3": "93d9",
	"./sounds/sendMessage.mp3": "b81b",
	"./user Icon.svg": "1e8d",
	"./volume_off_white_24dp.svg": "2375",
	"./volume_up_white_24dp.svg": "ea0e",
	"./web_asset.svg": "8503"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";